import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import importedDocumentRenameFailed, {
	type ImportedDocumentRenameFailedAction,
} from '@Application/Beneficiaries/ImportedDocuments/Actions/importedDocumentRenameFailed';
import importedDocumentRenamed, {
	type ImportedDocumentRenamedAction,
} from '@Application/Beneficiaries/ImportedDocuments/Actions/importedDocumentRenamed';
import type { ImportedDocumentPayload } from '@Application/Beneficiaries/ImportedDocuments/Actions/importedDocumentsFetched';
import type RenameImportedDocument from '@Application/Beneficiaries/ImportedDocuments/Commands/RenameImportedDocument';
import { patch } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = ImportedDocumentRenamedAction | ImportedDocumentRenameFailedAction;

export default (command: RenameImportedDocument) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await patch<ImportedDocumentPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/imported-documents/${command.importedDocumentId}`,
				command.toJSON(),
			);

			const action = importedDocumentRenamed(
				payload,
				command.subject.typeKey,
				command.subject.subjectId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = importedDocumentRenameFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
